import { Component, OnInit } from '@angular/core';
import { Pendencia } from 'src/app/models/pendencia';
import { MASKS } from 'ng-brazil';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PendenciaService } from 'src/app/services/pendencia.service';
import { MatDialog } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { IconesModalComponent } from 'src/app/modals/icones-modal/icones-modal.component';

@Component({
  selector: 'app-cadastrar-pendencia',
  templateUrl: './cadastrar-pendencia.component.html',
  styleUrls: ['./cadastrar-pendencia.component.scss']
})
export class CadastrarPendenciaComponent implements OnInit {
  idPendencia = '';
  pendencia = new Pendencia();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private pendenciaService: PendenciaService,
    public dialog: MatDialog,
    private router: Router,
    private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.idPendencia = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarPendencia();
    } else {
      this.pendencia = new Pendencia();
      this.atualizaDadosPendencia();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarPendencia() {
    this.carregandoService.mostra('buscarPendencia');

    this.pendenciaService.consultarPorId(this.idPendencia).subscribe(pendencia => {
      this.pendencia = pendencia;
      this.atualizaDadosPendencia();
    }, (erro) => {
      this.carregandoService.esconde('buscaPendencia');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosPendencia() {

    this.carregando = false;

    this.carregandoService.esconde('buscarPendencia');
  }

  salvar() {
    this.carregandoService.mostra('salvaPendencia');

    this.pendenciaService.salvar(this.pendencia).subscribe(() => {
      this.notificacaoService.sucesso('Pendencia salva com sucesso!!!');
      this.router.navigate(['/configuracoes/pendencias']).then(() => {
        this.carregandoService.esconde('salvaPendencia');
      });

    }, (erro) => {
      this.carregandoService.esconde('salvaPendencia');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarIcone() {
    const dialogRef = this.dialog.open(IconesModalComponent, {
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.pendencia.icone = result;
      }
    });
  }

  ngOnDestroy(): void {
  }
}

